import type { ReactNode } from "react";

/** 관리자 화면 머리 , 제목, 한 줄 설명, 오른쪽 도구 */
export function PageHead({ title, desc, aside }: { title: string; desc?: ReactNode; aside?: ReactNode }) {
  return (
    <header className="admin-head">
      <div className="min-w-0">
        <h1 className="admin-title">{title}</h1>
        {desc && <p className="admin-desc">{desc}</p>}
      </div>
      {aside && <div className="admin-toolbar">{aside}</div>}
    </header>
  );
}

/** 읽는 중,오류,빈 목록을 한 줄로 */
export function LoadState({ loading, error, empty, emptyText = "항목이 없습니다." }: { loading: boolean; error: string | null; empty?: boolean; emptyText?: string }) {
  if (error) {
    return (
      <p role="alert" className="note note-danger text-label">
        {error}
      </p>
    );
  }
  if (loading) return <p className="text-caption text-ink-subtle">읽는 중…</p>;
  if (empty) return <p className="text-caption text-ink-subtle">{emptyText}</p>;
  return null;
}
